import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Switch from '@mui/material/Switch';

function StartScreen({ onStartGame }) {
  const [level, setLevel] = useState('facil');
  const [wordCount, setWordCount] = useState(10);
  const [autoRec, setAutoRec] = useState(true);

  const handleStartGame = () => {
    onStartGame(level, wordCount, autoRec);
  };

  // habilitar gravacao automatica
  const handleChange = (event) => {
    setAutoRec(event.target.checked);
  };
  return (
    <div>
      <div className="bga"></div>
      <div className="bga bg2"></div>
      <div className="bga bg3"></div>
      <div className="start-screen content">
        <div className="start-options">
          <div className="option-group">
            <label htmlFor="level-select">NIVEL</label><br />
            {/* <select
              id="level-select"
              value={level}
              onChange={(e) => setLevel(e.target.value)}
              className="level-select"
            >
              <option value="facil">Fácil</option>
              <option value="medio">Médio</option>
              <option value="dificil">Difícil</option>
            </select> */}


            <ToggleButtonGroup
              id="level-select"
              color="primary"
              value={level}
              exclusive
              onChange={(e) => setLevel(e.target.value)}
              aria-label="Platform"
            >
              <ToggleButton value="facil">Fácil</ToggleButton>
              <ToggleButton value="medio">Médio</ToggleButton>
              <ToggleButton value="dificil">Difícil</ToggleButton>
            </ToggleButtonGroup>

          </div>

          <div className="option-group">
            <label htmlFor="word-count">PALAVRAS</label>
            <input
              type="number"
              id="word-count"
              min="1"
              max="100"
              value={wordCount}
              onChange={(e) => setWordCount(parseInt(e.target.value))}
              className="word-count-input"
            />        

            <Slider
              aria-label="Palavras"
              defaultValue={30}
              value={wordCount}
              valueLabelDisplay="auto"
              shiftStep={30}
              step={10}
              marks
              min={1}
              max={100}
              onChange={(e) => setWordCount(parseInt(e.target.value))}
            />            

            <label htmlFor="record-select">GRAVADOR</label><br />   
            <Switch
              id="record-select"
              checked={autoRec}
              onChange={handleChange}
              inputProps={{ 'aria-label': 'controlled' }}
            />
          </div>

          <button onClick={handleStartGame} className="start-button">
            INICIAR JOGO
          </button>
        </div>

        <div className="keyboard-hint">
          <h3>Como Jogar:</h3>
          <p>1. Inicie o jogo</p>
          <p>2. Pressione a BARRA DE ESPAÇO ou clique no botão para avançar</p>
          <p>3. O jogo termina após a última palavra</p>
          <p>4. Sua pontuação depende do nível e do número de acertos</p>
          <p>5. Faça o download do audio gravado, e estude a sua pronuncia!</p>
        </div>
      </div>
    </div>
  );
}

export default StartScreen;
